// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "dist/js/" + chunkId + "." + "4cb86d7e99a2d986" + ".js";
};